(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1279px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  const desktopMenuQuery = window.matchMedia('(min-width: 1280px)');

  function initDesktopHoverMenus() {
    // O mega menu (pf-mega-menu.js) traz hover próprio, com atraso de intenção,
    // fecho dos irmãos e Escape. Dois sistemas de hover no mesmo <details>
    // lutavam (abertura instantânea aqui vs 90ms lá). Com o mega menu desligado
    // no editor, .pf-mega não existe e isto volta a correr como antes.
    if (document.querySelector('.header__inline-menu.pf-mega')) return;

    document.querySelectorAll('.header__inline-menu header-menu details').forEach((details) => {
      if (details.dataset.hoverInit === 'true') return;

      const summary = details.querySelector('summary');
      if (!summary) return;

      let closeTimeout;

      const openMenu = () => {
        window.clearTimeout(closeTimeout);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        window.clearTimeout(closeTimeout);
        closeTimeout = window.setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 80);
      };

      details.addEventListener('mouseenter', () => {
        if (!desktopMenuQuery.matches) return;
        openMenu();
      });

      details.addEventListener('mouseleave', () => {
        if (!desktopMenuQuery.matches) return;
        closeMenu();
      });

      summary.addEventListener('click', (event) => {
        if (!desktopMenuQuery.matches) return;
        if (event.detail > 0) event.preventDefault();
      });

      details.dataset.hoverInit = 'true';
    });
  }

  function closeMenusWhenLeavingDesktop() {
    if (desktopMenuQuery.matches) return;

    document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach((details) => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopHoverMenus);
  } else {
    initDesktopHoverMenus();
  }

  closeMenusWhenLeavingDesktop();
  document.addEventListener('shopify:section:load', initDesktopHoverMenus);
  desktopMenuQuery.addEventListener('change', closeMenusWhenLeavingDesktop);

  } catch(e) { console.error(e); }
})();
})();
